import { PersistGate } from 'redux-persist/es/integration/react';
import './App.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import store, { persistor } from './store';
import theme from './themes';
import AppRoutes from './routes';
import { SnackbarProvider } from 'notistack';
import ModalProvider from 'mui-modal-provider';
import './fonts';
import { useEffect } from 'react';

const LOCAL_STORAGE_KEY = 'maintenanceModeActive';
function App(): JSX.Element {

  // useEffect(() => {
  //   const checkMaintenance = async () => {
  //     try {
  //       const res: any = await fetch('/api/onboarding/checkIfMaintenanceFlagEnabled', { cache: 'no-store' });
  //       const data = await res.json();
  //       if (data.maintenanceMode) {
  //         const alreadyReloaded = localStorage.getItem(LOCAL_STORAGE_KEY) === 'true';
  //         if (!alreadyReloaded) {
  //           localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  //           window.location.reload();
  //         }
  //       } else {
  //         localStorage.removeItem(LOCAL_STORAGE_KEY);
  //       }
  //     } catch {
  //       localStorage.removeItem(LOCAL_STORAGE_KEY);
  //     }
  //   };

  //   const intervalId = setInterval(checkMaintenance, 20 * 1000); // check every 20 sec
  //   return () => clearInterval(intervalId);
  // }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <ModalProvider>
            <div>
              <SnackbarProvider
                maxSnack={2}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}>
                <AppRoutes />
              </SnackbarProvider>
            </div>
          </ModalProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
